import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import {
  getAdminEmpresa,
  getGestorEmpresa, getOperadorEmpresa,
  PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import { formatarReal } from '../../util/numberUtil';
import iconAudoria from  '../../img/auditoria.png';
import buscarUltimosHistoricosPreco from '../../actions/preco/buscarUltimosHistoricosPreco';

export class Preco extends React.Component {
  selecionarPreco (preco) {
    this.props.changeFieldValue('formularioCadastroPreco',
      'idPreco', preco.id);
    this.props.changeFieldValue('formularioCadastroPreco',
      'cidadeOrigem', { label: preco.cidadeOrigem.nome, value: preco.cidadeOrigem.id });
    this.props.changeFieldValue('formularioCadastroPreco',
      'cidadeDestino', { label: preco.cidadeDestino.nome, value: preco.cidadeDestino.id });
    this.props.changeFieldValue('formularioCadastroPreco',
      'valor', preco.valor);
    this.props.changeFieldValue('formularioCadastroPreco',
      'tipo', { label: preco.descricaoTipoPreco, value: preco.tipoPreco });
    this.props.changeFieldValue('formularioCadastroPreco',
      'valorAntt', preco.valorAntt);
    this.props.changeFieldValue('formularioCadastroPreco',
      'tarifaSeguro', preco.tarifaSeguro);
  }


  render () {
    return (
      <div className="geral">
        <div className="resumo">
          <div className="row">
            <div className="col-lg-3 col-xl-3">
              <span className="titulo-mobile">Cidade origem:&nbsp;</span>{this.props.preco.cidadeOrigem.nomeComUf}
            </div>

            <div className="col-lg-3 col-xl-3">
              <span className="titulo-mobile">Cidade destino:&nbsp;</span>{this.props.preco.cidadeDestino.nomeComUf}
            </div>

            <div className="col-lg-2 col-xl-2">
              <span className="titulo-mobile">Tipo:&nbsp;</span>{this.props.preco.descricaoTipoPreco}
            </div>

            <div className="col-lg-2 col-xl-2">
              <span className="titulo-mobile">Valor R$:&nbsp;</span>{formatarReal(this.props.preco.valor)}
            </div>

            <div className="col-lg-2 col-xl-2">
              <Autorizacao
                perfisPermitidos={[PERFIL_ADMIN,
                  getAdminEmpresa(this.props.idEmpresa),
                  getGestorEmpresa(this.props.idEmpresa),
                  getOperadorEmpresa(this.props.idEmpresa)]}>
                <div className="acoes">
                  <div className="botoes">
                    <button type="button" className="btn btn-excluir"
                            data-toggle="modal" key={this.props.preco.id}
                            data-target="#modalConfirmacaoExclusaoPreco"
                            onClick={() => this.props.selecionarPreco(this.props.preco)}>
                      <i className="material-icons nav-icon">&#xe872;</i>
                    </button>
                    <button type="button" className="btn btn-editar ml-2"
                            data-toggle="modal"
                            data-target="#modalCadastrarPreco"
                            onClick={() => this.selecionarPreco(this.props.preco)}>
                      <i className="material-icons nav-icon">&#xe150;</i>
                    </button>
                    <button type="button" className="btn ml-2"
                            data-toggle="modal"
                            title='Buscar últimos Históricos Preços'
                            data-target="#modalHistoricoPrecos"
                            onClick={() => {                                
                                this.props.selecionarPreco(this.props.preco)
                                this.props.buscarUltimosHistoricosPreco(this.props.preco.id, this.props.empresaSelecionada.id)                                
                            }}>                                                
                        <img src={iconAudoria} alt="Históricos Valores" />
                    </button>
                  </div>
                </div>
              </Autorizacao>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export function mapStateToProps (state) {
  return {
    empresaSelecionada: state.empresaSelecionada
  }
}

export default connect(mapStateToProps, { changeFieldValue, buscarUltimosHistoricosPreco })(reduxForm({
  form: 'formularioCadastroPreco'
})(Preco))
